import * as yup from 'yup';

// const SUPPORTED_FORMATS = ['application/pdf', 'image/jpeg', 'image/png'];
// const FILE_SIZE = 351 * 1024; // 351 KB

const Schema = yup.object({
  merchentRegion: yup.string().required("Merchent Region is required!"),
  merchentType: yup.string().required("Merchent Type is required!"),
  name: yup.string().required("Name is required!"),
  address: yup.string().required("Address is required!"),
  city: yup.string().required("City is required!"),
  pincode: yup.string().required("Pincode is required!"),
  state: yup
  .mixed()
  .transform((originalValue) => originalValue?.value ?? "")
  .required("State is required!"),

  country: yup
  .mixed()
  .transform((originalValue) => originalValue?.value ?? "")
  .required("Country is required!"),


  contactName: yup.string().required("Contact Name is required!"),
  mobile: yup
  .string()
  .required("Mobile is required!")
  .matches(/^[0-9]{1,15}$/, "Mobile number must be between 1 and 15 digits"),
    // .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
  email: yup.string()
    .required("Email is required!")
    .email("Email must be a valid email address"),

  //  gst: yup.string().when(['merchentRegion', 'merchentType'], {
  //   is: (merchentRegion, merchentType) => merchentRegion === '1' && merchentType === 'business',
  //   then: schema => schema.required('GST is required'),
  //   otherwise: schema => schema.notRequired(),
  //  }),

  //  vat: yup.string().when(['merchentRegion', 'merchentType'], {
  //   is: (merchentRegion, merchentType) => merchentRegion === '2' && merchentType === 'business',
  //   then: schema => schema.required('VAT is required'),
  //   otherwise: schema => schema.notRequired(),
  //  }),

   taxNumber: yup.string().when(['merchentType'], {
    is: (merchentType) =>  merchentType === 'business',
    then: schema => schema.required('TAX Number is required').matches(/^[a-zA-Z0-9]{1,15}$/, 'TAX Number must be between 1 and 15 digits'),
    otherwise: schema => schema.notRequired(),
   }),

  


  terms: yup.boolean()
    .oneOf([true], "You must accept the terms and conditions"),

  guidline: yup.boolean()
    .oneOf([true], "You must accept the Branding Guidelines"),
});

export default Schema;
